module.exports = __webpack_public_path__ + "media/promo/panasonic/images/icons/i-2-0a6b73d7637d6be6327503b9a3d2f487.svg";